import axios from 'axios'
import api from '@/services/api'

export default {
    async fetchCompany () {
      return await axios.get(api.baseUrl + 'company' )
    },
    async fetchHead() {
        try {
            var head = await axios.get(api.baseUrl + 'head')
            head = await head.data
            return head
        } catch(err) {
            console.log(err)
        }
        //return await axios.get(api.baseUrl + 'head').json
    }
}